/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PriceDisplay_displayInfo$ref = any;
export type PriceDisplay_displayInfo = {
    readonly pricing: {
        readonly quantityDisplay: string | null;
        readonly showSold: boolean | null;
        readonly showUnavailable: boolean | null;
        readonly showPUR: boolean | null;
        readonly showNet: boolean | null;
        readonly showSale: boolean | null;
        readonly showRetail: boolean | null;
        readonly showOriginal: boolean | null;
        readonly showOnHold: boolean | null;
        readonly showOnHoldCustom: boolean | null;
        readonly showListPriceLabel: boolean | null;
    } | null;
    readonly " $refType": PriceDisplay_displayInfo$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PriceDisplay_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "quantityDisplay",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showUnavailable",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showPUR",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showNet",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSale",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRetail",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showOriginal",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showOnHold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showOnHoldCustom",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showListPriceLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '3bcfc5d8bc3e4a9581923992b5aa7f8b';
export default node;
